import {
  AlertIcon,
  Badge,
  Button,
  Card,
  CardContent,
  CheckIcon,
  Control,
  ControlError,
  ControlHelper,
  ControlSuccess,
  Label,
  Modal,
  Select,
  SelectOption,
  TextArea,
} from "@forge/common";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { ChangeEvent, useEffect, useRef, useState } from "react";
import { AppDispatch } from "../../store";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { useDispatch } from "react-redux";
import { getCertificate } from "../../store/Tenant/tenant-actions";
import Loader from "../Loader/Loader";
import { setErrorPopupsusingErrorCode } from "./setErrorPopupsusingErrorCode";
import { IErrorProps } from "../../models";
import { serverErrorClose } from "../SharedComponents/serverErrorClose";
import { validateCSR } from "../GenerateCertificate/validateCSR";
import updateErrorList from "../../utils/methods/updateErrorList";
import ErrorHandlingComponent from "../SharedComponents/ErrorHandlingComponent";
import "./GenerateCertificate.scss";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../localization/keys";

export default interface OptionsProduct {
  productId: string;
  productName: string;
}

interface props {
  closeHandler(): void;
  tenantId: string;
  data: Array<OptionsProduct>;
}

export const GenerateCertificate: any = (props: props) => {
  const [t] = useTranslation();
  const [selectedProducts, setSelectedProducts] = useState<string>("");
  const [certificateString, setCertificateString] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const result = useRef<string>("");

  ///////////////Error Handling////////////////////////
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogCopied, setOpenDialogCopied] = useState(false);
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  // const [selectedOrgsObj, setSelectedOrgsObj] = useState<any>({});
  const [validatedCSRStatus, setValidatedCSRStatus] = useState<string>("");
  const [csrError, setCsrError] = useState<string>("");

  ///////////////Error Handling////////////////////////

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    if (
      errorListGlobal.some((x) => x.errorCode === undefined) &&
      !openDialogNoURLError
    ) {
      setOpenDialogNoURLError(true);
    }

    if (errorListGlobal.some((x) => x.errorCode === 400) && !openToastError) {
      setOpenToastError(true);
    }
    if (
      errorListGlobal.some(
        (x) =>
          x.errorCode !== undefined &&
          x.errorCode !== 400 &&
          x.errorCode !== null &&
          x.errorCode !== 204
      ) &&
      !openDialogServerError
    ) {
      setOpenDialogServerError(true);
    }
  }, [errorListGlobal]);

  //////////////Error Handling////////////////////////
  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(result.current)
      .then(() => {
        setOpenDialogCopied(true);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const GetResult = () => {
    return (
      <>
        <Control>
          <p>
            {t(localeKeyMap.certificateGeneratedSuccessfully)}{' '}
            <CheckCircleIcon sx={{ color: 'green' }} />
          </p>
        </Control>

        <Control>
          <Label className="align-label-certificate">
            {t(localeKeyMap.signedCertificate)}
            <Button
              aria-label={t(localeKeyMap.copy)}
              icon={<ContentCopyIcon fontSize="small" />}
              iconPosition="left"
              size="regular"
              variant="quiet-primary"
              onClick={handleCopyClick}
            />
          </Label>
          <TextArea disabled value={result.current} rows={3} id={""}></TextArea>

          {openDialogCopied && (
            <ControlSuccess>{t(localeKeyMap.copiedToClipboard)}</ControlSuccess>
          )}
        </Control>
      </>
    );
  };

  const validatorString = (certificateString: string) => {
    setCsrError("");
    try {
      const validateAllChecks = validateCSR(
        certificateString,
        selectedProducts,
        props.tenantId
      );

      if (validateAllChecks) {
        setValidatedCSRStatus(validateAllChecks);
      } else {
        setCsrError(validateAllChecks);
      }
    } catch (error: any) {
      setCsrError(error.message);
    }
  };

  const onSubmitHandeller = () => {
    const postData: any = {
      certificateGenerationRequest: certificateString,
      products: selectedProducts,
      tenantId: props.tenantId,
    };

    setIsLoading(true);
    dispatch(getCertificate(postData))
      .unwrap()
      .then((response) => {
        result.current = response;
        setSuccess(true);
        // setSuccessListGlobal((prevState) =>
        //   updateSuccessList("Certificate generated successfully", [...prevState])
        // );
        // props.closeHandler();
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => setIsLoading(false));
  };

  const onchangeText = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    setValidatedCSRStatus("");
    setCertificateString(event.target.value);
  };

  const contentCard = (
    <div>
      <form>
        <Card>
          <CardContent>
            {success ? (
              <GetResult />
            ) : (
              <>
                {" "}
                <Control>
                  <Label>{t(localeKeyMap.selectProduct)}</Label>
                  <Select
                    aria-labelledby="test"
                    aria-label={t(localeKeyMap.selectAProduct)}
                    height={5}
                    data-testid="selectProducts"
                    id="selectProducts"
                    key="products-select"
                    placeholder={t(localeKeyMap.selectAProduct)}
                    size="regular"
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      setValidatedCSRStatus("");
                      setSelectedProducts(event.target.value);
                    }}
                    value={selectedProducts}
                  >
                    {props.data.map((data) => (
                      <SelectOption
                        key={data.productId}
                        value={data.productId}
                        label={data.productName}
                      ></SelectOption>
                    ))}
                  </Select>
                </Control>
                <Control>
                  <Label className="align-label-certificate">
                    {t(localeKeyMap.certificateSigningRequest)}
                    <Button
                      aria-label={t(localeKeyMap.validateCSR)}
                      disabled={
                        certificateString == "" || selectedProducts == ""
                      }
                      icon={
                        validatedCSRStatus ? (
                          <CheckIcon color="green" />
                        ) : (
                          <AlertIcon color="red" />
                        )
                      }
                      iconPosition="left"
                      size="regular"
                      data-testid="validateCSR"
                      title={t(localeKeyMap.validateCSR)}
                      variant="quiet-primary"
                      onClick={() => validatorString(certificateString)}
                    />
                  </Label>

                  <TextArea
                    data-testid="CertificateString"
                    id="CertificateString"
                    placeholder="-----BEGIN CERTIFICATE REQUEST-----
                      AwIDRwAwRAIgfcrIssRivmQ6fTJtkBR3PkkVaVTZ0pyu0G/gLjkWy64CIGbTSf0G3rGhBwXnke1f/jkDRfzKocveyDb3mDqR8TGV
                      -----END CERTIFICATE REQUEST-----"
                    rows={3}
                    size="regular"
                    onChange={onchangeText}
                  />
                  {csrError && <ControlError>{csrError}</ControlError>}
                  {validatedCSRStatus == "" && (
                    <ControlHelper>
                      {t(localeKeyMap.pleaseValidateCSR)}
                    </ControlHelper>
                  )}
                  {validatedCSRStatus && (
                    <ControlSuccess>{validatedCSRStatus}</ControlSuccess>
                  )}
                </Control>
              </>
            )}
          </CardContent>
        </Card>
      </form>
      {isLoading && <Loader />}
    </div>
  );

  return (
    <>
      <Modal
        className="mx-auto w-[80vw] "
        children={contentCard}
        //  onBackdropClick={props.closeHandler}
        onModalClose={props.closeHandler}
        //backdrop
        footerLeft={
          success ? (
            <p></p>
          ) : (
            <Button onClick={props.closeHandler} variant="quiet-secondary">
              {t(localeKeyMap.cancel)}
            </Button>
          )
        }
        footerRight={
          success ? (
            <Button onClick={props.closeHandler}>{t(localeKeyMap.ok)}</Button>
          ) : (
            <Button
              onClick={onSubmitHandeller}
              disabled={
                // certificateString == "" ||
                // selectedProducts == "" ||
                validatedCSRStatus == ""
              }
            >
              {t(localeKeyMap.submit)}
            </Button>
          )
        }
        title={t(localeKeyMap.generateCertificate)}
      ></Modal>

      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
    </>
  );
};
